import { z } from 'zod';

import { certificateRoleEnum } from '~/modules/clients/common';
import {
  zodFeaturesSchema,
  zodStrategicMultiplierSchema,
} from '~/modules/clients/companyAccounts/utils';

import {
  EmailSchema,
  PhoneNumberSchema,
  withoutObjectKeysWhereValueIs,
} from '@vestigas/utils';

export const zodCreateCompanyAccountEndpointSchema = z.tuple([
  z.literal('company_account'),
]);

export const zodCreateCompanyAccountPayloadSchema = z
  .object({
    name: z.string().trim().min(1),
    data: z.object({
      defaultSignatureRole: z
        .union([z.literal(''), certificateRoleEnum])
        .nullish()
        .transform((value) => value ?? ''),
      featureFlags: z.object(zodFeaturesSchema),
      supportEmail: z
        .union([EmailSchema, z.literal('')])
        .nullish()
        .transform((value) => value || null),
      supportPhoneNumber: z
        .union([PhoneNumberSchema, z.literal('')])
        .nullish()
        .transform((value) => value || null),
    }),
    strategicMultiplier: zodStrategicMultiplierSchema.optional(),
  })
  .transform((data) => withoutObjectKeysWhereValueIs(data, [undefined]));

/**
 * `CreatedCompanyAccount` in the OpenAPI spec. Only `code`/`message` are
 * required there; `companyAccountId`/`baseOuId` are nullable.
 */
export const zodCreateCompanyAccountResponseSchema = z.object({
  baseOuId: z.uuid().nullish(),
  code: z.number(),
  companyAccountId: z.uuid().nullish(),
  message: z.string(),
});
